import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface PendingScoreProps {
  className?: string;
  label?: string;
}

const PENDING_REASON =
  "Risk scoring isn't available for this combination yet — missing site coordinates, a value chain stage mapping, or vulnerability reference data.";

/** One shared "not available yet" pill — every risk-dependent slot on the
 * Results Overview page uses this instead of a bespoke empty state. */
export function PendingScore({ className, label = "Not available yet" }: PendingScoreProps) {
  return (
    <Badge
      title={PENDING_REASON}
      className={cn("border-dashed border-muted-foreground/40 bg-muted text-muted-foreground", className)}
    >
      {label}
    </Badge>
  );
}
